var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticStyle:{"margin":"5px auto"},attrs:{"text":"","dense":"","outlined":"","color":"deep-orange","icon":"mdi-alert","max-width":"768"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }